import React from "react";
import { appColors, appType } from "../../utils/appTheme";
import AppCard from "./AppCard";

/**
 * Tarjeta de estadística: icono opcional, label en MAYÚSCULAS (10.5px),
 * valor grande (24px, peso 400) color-codeado, subtítulo/caption.
 */
const StatCard = ({
  icon,
  label,
  value,
  valueColor = appColors.ink,
  sub,
  subColor = appColors.ink2,
  variant = "default",
  onClick,
  style,
}) => (
  <AppCard variant={variant} onClick={onClick} padding={16} style={style}>
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {icon && (
        <span style={{ color: valueColor, fontSize: 18, display: "inline-flex" }}>
          {icon}
        </span>
      )}
      {label && <span style={{ ...appType.statLabel }}>{label}</span>}
      <span
        style={{
          ...appType.stat,
          color: valueColor,
        }}
      >
        {value}
      </span>
      {sub && (
        <span style={{ ...appType.bodySm, color: subColor }}>{sub}</span>
      )}
    </div>
  </AppCard>
);

export default StatCard;
